import { render, staticRenderFns } from "./equityInvest.vue?vue&type=template&id=89261d3a&scoped=true"
import script from "./equityInvest.vue?vue&type=script&lang=js"
export * from "./equityInvest.vue?vue&type=script&lang=js"
import style0 from "./equityInvest.vue?vue&type=style&index=0&id=89261d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89261d3a",
  null
  
)

export default component.exports